import React from 'react';
import { useEffect } from 'react';
import s from './EsriMap.module.css'; // Assuming you have a CSS module for styling
import RawHtml from '../RawHtml'; // Assuming you have a RawHtml component

interface ReactionPanelTooltipProps {
    reactionPanelContent: { value: string }[];
}

const ReactionPanelTooltip: React.FC<ReactionPanelTooltipProps> = ({
    reactionPanelContent,
}) => {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && reactionPanelContent) {
                console.log('Escape key pressed', event);
                (document.activeElement as HTMLElement)?.blur();
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return (
        <div className={s.webmap__dialog__header__tooltipwrapper}>
            <button
                className={`material-icons ${s.webmap__dialog__header__icon}`}
                aria-describedby="reactioninformation_tooltip">
                info
            </button>
            <div
                className={`${s.webmap__dialog__header__tooltip}`}
                id="reactioninformation_tooltip">
                {reactionPanelContent.map((contentItem, index) => (
                    <RawHtml key={index} html={contentItem.value} />
                ))}
            </div>
        </div>
    );
};

export default ReactionPanelTooltip;
